module.exports = __webpack_public_path__ + "img/brand.d70f441e.png";